<template>
  <div class="home">
    <header class="header">
      <h1>Lottery - 抽奖系统</h1>
      <hr>
    </header>
    <main class="main">
      <section class="introduction">
        <h2>系统概述</h2>
        <p>
            &nbsp; &nbsp;本项目是一个抽奖系统，它是营销平台下的一个子系统，是一个抽奖大转盘。转盘中有一些奖品，点击抽奖后返回中奖信息。核心流程包括：参与活动、执行抽奖、奖品发放。
        </p>
      </section>
      <section class="architecture">
        <h2>系统架构</h2>
        <p>项目采用了 DDD 的分层结构来搭建整个抽奖系统架构，主要包括以下几个领域：</p>
        <ul>
          <li><strong>活动领域：</strong>活动的管理（发布部署，参与活动，状态流转）</li>
          <li><strong>抽奖领域：</strong>具体的抽奖策略</li>
          <li><strong>奖品领域：</strong>工厂模式进行奖品的发放</li>
          <li><strong>规则领域：</strong>规则引擎，对参与的用户过滤，比如可以依据用户的年龄、性别等是否能参与活动</li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'Home'
};
</script>

<style scoped>
.home {
  max-width: 800px;
  margin: 20px auto;
  font-family: Arial, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
}

.header h1 {
  color: #007bff;
  font-size: 2.5em;
}

.header p {
  color: #6c757d;
  font-size: 1.2em;
}

.main {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.introduction,
.architecture {
  padding: 20px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}

.introduction h2,
.architecture h2 {
  color: #007bff;
  margin-bottom: 10px;
}

.architecture ul {
  list-style-type: none;
  padding-left: 0;
}

.architecture li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 10px;
}

.architecture li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background-color: #007bff;
  border-radius: 50%;
}
</style>